import { reactive } from "@vue/reactivity"

const states = reactive({
    isSidebarClose: false,
    isUserClose: null,
})

const mutations = {
    switchSidebarClose: (status) => {
        states.isSidebarClose = !status;
    },
    switchUserClose: (status) => {
        states.isUserClose = !status;
    }
}

export default {
    states,
    mutations
}